<p-confirmDialog key="category"></p-confirmDialog>
<p-table [value]="categories" dataKey="id" editMode="row" responsiveLayout="scroll" selectionMode="single" [(selection)]="selectedCategory">
    <ng-template pTemplate="header">
        <tr>
            <th i18n="@@media-category-manager.table.header.name">Name</th>
            <th i18n="@@media-category-manager.table.header.color">Color</th>
            <th style="width:8rem"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="caption">
        <div class="flex">
                <div>
                    <button pButton icon="far fa-plus" (click)="addCategory()" ></button>
                </div>
            <div>
                <p-button *ngIf="selectedCategory" type="button" icon="far fa-trash" [rounded]="true" severity="danger"
                        (click)="onRowDelete(selectedCategory, getSelectedIndex())" class="ml-2"></p-button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="body" let-category let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="category" [pSelectableRow]="category">
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <input pInputText type="text" [(ngModel)]="category.name">
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{category.name}}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <color-circle [color]="category.color" (onChange)="handleColorChange(category,$event)"
                            [colors]="avColors">
                        </color-circle>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div class="flex-1 ">
                            <color-circle-swatch class="manageCategoriesColorWrapper" [color]="category.color"></color-circle-swatch>
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>

            <td style="text-align:center">
                <p-button *ngIf="!editing" type="button" pInitEditableRow icon="far fa-pen" [text]="true"
                    (click)="onRowEditInit(category)" ></p-button>
                <p-button *ngIf="editing" type="button" pSaveEditableRow icon="far fa-check" [text]="true"
                    (click)="onRowEditSave(category,ri)" [rounded]="true" severity="success" class="mr-2"></p-button>
                <p-button *ngIf="editing" type="button" pCancelEditableRow icon="far fa-times" [text]="true"
                    (click)="onRowEditCancel(category, ri)" [rounded]="true" severity="danger"></p-button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" i18n="@@media-category-manager.table.empty">No categories created yet</td>
        </tr>
    </ng-template>
</p-table>
